import AElement from "aloha-vue/src/AElement/AElement";

import MainAPI from "../CompositionAPI/mainAPI";
import CurrentIconsAPI from "./CompositionAPI/currentIconsAPI";

// @vue/component
export default {
  name: "UiObjekticonVergabeConfigSelectionReadOnly",
  components: {
    AElement,
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: Array,
      default: undefined,
    },
  },
  setup(props) {
    const {
      allIcons,
      loading,
      loadObjekticons,
    } = MainAPI(props);

    const {
      currentIcons,
    } = CurrentIconsAPI(props, {
      allIcons,
    });

    loadObjekticons();

    return {
      allIcons,
      currentIcons,
      loading,
      loadObjekticons,
    };
  },
};
